import { useRef, useState } from "react";
import { usePwaUpdate } from "./pwa_update";
import { UpdateCoordinator } from "./update_coordinator";
import { WorkspaceApplication } from "./workspace_application";

/** Renders Shotboard's application shell and static-update notices. */
export function App() {
  const { offlineReady, updateAvailable, applyUpdate } = usePwaUpdate();
  const updateCoordinator = useRef(new UpdateCoordinator()).current;
  const [applyingUpdate, setApplyingUpdate] = useState(false);

  /** Flushes canonical local work before activating and reloading into a waiting version. */
  const handleApplyUpdate = async (): Promise<void> => {
    setApplyingUpdate(true);
    await updateCoordinator.apply(applyUpdate);
    setApplyingUpdate(false);
  };

  return (
    <>
      <WorkspaceApplication registerUpdateFlush={updateCoordinator.register} />
      {offlineReady ? (
        <aside className="offline-ready" aria-label="Offline status">
          Ready offline
        </aside>
      ) : null}
      {updateAvailable ? (
        <aside className="update-notice" aria-live="polite">
          <p>A new Shotboard version is ready.</p>
          <button type="button" disabled={applyingUpdate} onClick={() => void handleApplyUpdate()}>
            {applyingUpdate ? "Saving and updating…" : "Save and update"}
          </button>
        </aside>
      ) : null}
    </>
  );
}
